import { axiosPath } from "@/axios-path.js";
//fetchExtraCreditReport
export default {
  namespaced: true,
  state: {
    clone_config_path: {
      rider_id: 0,
      datetime_start: null,
      datetime_end: null
    },
    config_path: {
      rider_id: 0,
      datetime_start: null,
      datetime_end: null
    },
    extra_credit_zone_report_summary: {},
    extra_credit_zone_report_list: [],
    export_extra_credit_zone_format: []
  },
  mutations: {
    resetState(state) {
      state.clone_config_path = {
        rider_id: 0,
        datetime_start: null,
        datetime_end: null
      };
      state.config_path = {
        rider_id: 0,
        datetime_start: null,
        datetime_end: null
      };
      state.extra_credit_zone_report_summary = {};
      state.extra_credit_zone_report_list = [];
      state.export_extra_credit_zone_format = [];
    },
    fetchReportList(state, data) {
      state.extra_credit_zone_report_list = data;
      let count_no = 1;
      for (let val of state.extra_credit_zone_report_list) {
        val.no = count_no++;
        val.no_default = count_no - 1;
      }
    },
    getReportSummary(state, data) {
      state.extra_credit_zone_report_summary = {
        point: 0,
        tax: 0
      };
      for (let val of data) {
        state.extra_credit_zone_report_summary.point =
          state.extra_credit_zone_report_summary.point + val.point;
      }
    },
    getExportReportForm(state) {
      state.export_extra_credit_zone_format = [];
      for (let val of state.extra_credit_zone_report_list) {
        let index = state.extra_credit_zone_report_list.indexOf(val);
        let push_data = {
          No: index + 1,
          order_code: val.order_code,
          date: val.date,
          rider: val.rider,
          remark: val.remark,
          point: val.point
            ? parseFloat(val.point)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          note: val.note
        };
        state.export_extra_credit_zone_format.push(push_data);
      }
    },
    getExportSummary(state) {
      if (state.export_extra_credit_zone_format.length > 0) {
        let push_data_2 = {
          order_code: "Total credit point",
          point: state.extra_credit_zone_report_summary.point
            ? parseFloat(state.extra_credit_zone_report_summary.point)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00"
        };
        state.export_extra_credit_zone_format.push(push_data_2);
      }
    },
    cloneConfigPath(state) {
      state.clone_config_path = JSON.parse(JSON.stringify(state.config_path));
    }
  },
  actions: {
    async fetchReportList({ rootState, commit, state, dispatch }, config_path) {
      let url =
        rootState.api_urls.fetchExtraCreditReport_fetchReportList +
        config_path.rider_id +
        "/" +
        config_path.datetime_start +
        "/" +
        config_path.datetime_end;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("fetchReportList", res.data);
        commit("getReportSummary", res.data);
        commit("getExportReportForm");
        commit("getExportSummary");
        commit("cloneConfigPath");
        return res;
      }
    }
  },
  getters: {}
};
